module.exports = __webpack_public_path__ + "static/recurring_payments-53648ccae912d4a22ff2195b09cba89d.png";